<template>
    <div class="warpper">
        <div class="flex align-center justify-between">
            <div class="page-title">服务中心</div>
            <router-link to="/member/service/record" class="page-operate">申请记录</router-link>
        </div>
        <empty v-if="lists.length === 0" :type="5"/>
        <div class="flex flex-direction">
            <div class="item flex flex-direction justify-center" v-for="(item,index) in lists" :key="index">
                <div class="title ovHide">{{item.title}}</div>
                <div class="content ovHide2">
                    {{item.desc}}
                </div>
                <div class="flex align-center justify-between">
                    <div class="flex flex-wrap align-center">
                        <div class="count"><span>{{item.count}}</span>项服务</div>
                        <div class="tag" v-for="(tag,position) in item.label" :key="position">{{tag}}</div>
                    </div>
                    <router-link class="look" :to="'/member/service/detail?id='+item.id">查看</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getServerList} from '@/api/member'

    export default {
        components: {},
        name: "serviceList",
        data() {
            return {
                lists: []
            }
        },
        created() {
            this.$emit('setIndex', [4], '服务中心')
            this.init()
        },
        computed: {},
        methods: {
            //  页面加载时请求
            async init() {
                let _data = await getServerList()
                if (_data.status === 200) {
                    _data.data.map(item=>{
                        item.label = item.label.filter(label=>  label)
                    })
                    this.lists = _data.data
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
        .item{
            width: 100%;
            background-color: #f3f7fb;
            border-radius: 10px;
            margin-top: 20px;
            padding: 11px 20px;
            .title {
                font-size: 22px;
                color: #0a2240;
                font-weight: bold;
                line-height: 23px;
            }
            .content {
                width: 100%;
                font-size: 16px;
                line-height: 26px;
                color: #4b648a;
                margin-top: 10px;
            }
            .count {
                min-width: 89px;
                height: 28px;
                line-height: 28px;
                background-color: #0a2240;
                border-radius: 10px;
                border: solid 1px #0a2240;
                font-size: 16px;
                color: #ffffff;
                text-align: center;
                padding: 0 12px;
                margin-top: 15px;
                margin-right: 20px;
                span {
                    color: #ff9600;
                    font-weight: bold;
                }
            }
            .tag {
                min-width: 82px;
                height: 28px;
                line-height: 28px;
                background-color: #f3f7fb;
                border-radius: 14px;
                border: solid 1px #0a2240;
                font-size: 14px;
                color: #0a2240;
                text-align: center;
                margin-top: 15px;
                margin-right: 20px;
                padding: 0 12px;
            }
            .look {
                width: 99px;
                height: 40px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                font-size: 16px;
                line-height: 40px;
                color: #ffffff;
                text-align: center;
            }
        }
    }

</style>